// dberr — menerjemahkan error mentah Postgres/PostgREST jadi kalimat yang bisa ditindaklanjuti.
//
// Kenapa ada: pesan seperti "new row violates row-level security policy" muncul apa adanya di layar
// kasir. Bagi pemakai itu tak berarti apa-apa, dan penyebab terseringnya bukan soal izin sama sekali
// melainkan SESI YANG SUDAH MATI — token kedaluwarsa → server tak lagi mengenali perannya → aturan
// keamanan menolak. Menebak sendiri "mungkin saya tak berhak" membuat orang berhenti bekerja padahal
// cukup login ulang. Jadi saat kena RLS, sesi diperiksa dulu, baru pesannya ditentukan.
import { supabase } from './supabase';

const RLS = /row-level security|row level security/i;

/** Pesan siap-tampil untuk sebuah error DB. Aman dipanggil dari mana pun (tak melempar). */
export async function pesanDbError(e: unknown, aksi = 'menyimpan'): Promise<string> {
  const msg = e instanceof Error ? e.message : String(e ?? '');
  if (!RLS.test(msg)) return msg || `Gagal ${aksi}.`;
  let sesiHidup = false;
  try { const { data } = await supabase().auth.getUser(); sesiHidup = !!data?.user; } catch { /* jaringan mati → anggap sesi tak terbukti */ }
  return sesiHidup
    ? `Anda tidak punya izin untuk ${aksi} ini. Minta Owner membuka aksesnya di Hak Akses.`
    : '🔒 Sesi Anda sudah berakhir — silakan login ulang, lalu coba simpan lagi.';
}
